import React from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { LinkContainer } from "react-router-bootstrap";
import DropdownButton from "react-bootstrap/DropdownButton";
import { CgProfile } from "react-icons/cg";
import { IoSettingsOutline } from "react-icons/io5";
import { VscSignOut } from "react-icons/vsc";

const headerMenuStyle = {
    // margin: "0.15em",
    marginLeft: "auto",
    marginRight: "0.1em",
    padding: "0.2em",
    // fontSize: "0.9em",
};

const buttonIconStyle = {
    marginRight: "0.2em",
};

const buttonStyle = {
    margin: "0.2em",
    alignItems: "center",
    display: "flex",
    fontSize: "0.9em",
    padding: "0.45em",
    paddingTop: "0.2em",
    paddingBottom: "0.2em",
};

const Header = ({ signOut, user }) => {
    return (
        <div style={headerMenuStyle}>
            <DropdownButton title={user.attributes.name.split(" ").shift()} size="sm" id="dropdown-menu-align-right">
                <LinkContainer to="/profile" style={buttonStyle}>
                    <Dropdown.Item>
                        <CgProfile style={buttonIconStyle} /> Profile
                    </Dropdown.Item>
                </LinkContainer>
                <LinkContainer to="/settings" style={buttonStyle}>
                    <Dropdown.Item>
                        <IoSettingsOutline style={buttonIconStyle} /> Settings
                    </Dropdown.Item>
                </LinkContainer>
                <Dropdown.Divider />
                <Dropdown.Item onClick={signOut} style={buttonStyle}>
                    <VscSignOut style={buttonIconStyle} /> Sign Out
                </Dropdown.Item>
            </DropdownButton>
        </div>
    );
};

export default Header;
